import { ErrorData } from 'ok-angular-shared/components';

export const appErrorCodes: ErrorData[] = [
  {
    code: 2,
    message: `Ukendt fejl`,
  },
  {
    code: 3,
    message: `Fejl i input`,
  },
  {
    code: 100,
    message: `Der er sket en uventet fejl.`,
  },
  {
    code: 666,
    message: `Navnet indeholder ugyldige tegn`,
  },
  {
    code: 10003,
    message: `Abonnementet blev ikke fundet`,
  },
  {
    code: 10006,
    message: `Hardwareprodukt-bestillingen blev ikke fundet`,
  },
  {
    code: 10011,
    message: `Installationen blev ikke fundet`,
  },
  {
    code: 10013,
    message: `Fejl ved hent af installationer`,
  },
  {
    code: 10015,
    message: `Der er tidligere registreret ekstraomkostninger på installationen, og det er derfor ikke muligt at tilføje flere ekstraomkostninger.`,
  },
  {
    code: 10017,
    message: `Kunne ikke hente skabeloner til oprettelse af ladestander`,
  },
  {
    code: 10018,
    message: `Det er ikke tilladt at tilføje ekstraomkostninger uden at uploade en aftaleseddel`,
  },
  {
    code: 10022,
    message: `Kunne ikke rette produkt`,
  },
  {
    code: 10023,
    message: `Fejl ved hent af produkter`,
  },
  {
    code: 10024,
    message: `Produktet blev ikke fundet`,
  },
  {
    code: 10026,
    message: `Kunne ikke hente produkter`,
  },
  {
    code: 10052,
    message: `Fejl ved upload af fil`,
  },
  {
    code: 10053,
    message: `Filen blev ikke fundet`,
  },
  {
    code: 10054,
    message: `Kunne ikke finde produktbetingelser`,
  },
  {
    code: 10060,
    message: `Fejl ved kundesøgning`,
  },
  {
    code: 10075,
    message: `Ingen kunde blev fundet for den angivne G4-konto`,
  },
  {
    code: 10076,
    message: `Den valgte nedtagningsmetode kan ikke bruges med kundens ejerskab`,
  },
  {
    code: 10077,
    message: `Fejl ved kald til G4`,
  },
  {
    code: 10081,
    message: `Kunne ikke låse ladestik op`,
  },
  {
    code: 10082,
    message: `Abonnementet kunne ikke opsiges da der er bestilt flytning. Annullér flytningen og prøv igen.`,
  },
  {
    code: 10083,
    message: `Abonnementet kunne ikke opsiges da der er bestilt overdragelse. Annullér overdragelsen og prøv igen.`,
  },
  {
    code: 10091,
    message: `Kunne ikke hente ladebrikker`,
  },
  {
    code: 10097,
    message: `Organisationen blev ikke fundet`,
  },
  {
    code: 10098,
    message: `Brugeren blev ikke fundet i OK User Service`,
  },
  {
    code: 10103,
    message: `Fejl ved kald til OK User Service`,
  },
  {
    code: 10108,
    message: `Abonnementet er annulleret`,
  },
  {
    code: 10104,
    message: `Kunne ikke afslutte installationen, da den er i forkert tilstand`,
  },
  {
    code: 10105,
    message: `Installation er ikke i afvent fakturering status`,
  },
  {
    code: 10109,
    message: `Indtastede G4 varenummer er ikke gyldigt`,
  },
  {
    code: 10113,
    message: `Fejl ved udskiftning af ladestander`,
  },
  {
    code: 10114,
    message: `Installationen er i forkert tilstand til at kunne udskifte ladestanderen`,
  },
  {
    code: 10120,
    message: `Installationen er i forkert tilstand eller har haft sin første opladning`,
  },
  {
    code: 10149,
    message: `Forkert kunde type`,
  },
  {
    code: 12111,
    message: `Screening ikke fundet`,
  },
  {
    code: 12112,
    message: `Screening allerede udfyldt`,
  },
  {
    code: 12113,
    message: `Ugyldigt filformat`,
  },
  {
    code: 12114,
    message: `Den valgte fil er for stor`,
  },
  {
    code: 12117,
    message: `Screening allerede udfyldt`,
  },
  {
    code: 12118,
    message: `Bankoplysninger mangler - kontonummer eller registreringsnummer er tomt`,
  },
  {
    code: 12119,
    message: `Bankoplysningerne er ugyldige, de indtastede værdier indeholder måske andet end tal`,
  },
  {
    code: 12123,
    message: `Screening i forkert tilstand`,
  },
  {
    code: 12190,
    message: `Det er ikke tilladt at bestille en akut omplacering`,
  },
  {
    code: 19006,
    message: `Fejl! Kaldet til G4 for at hente elaftaler for den aktuelle konto fejlede`,
  },
  {
    code: 100067,
    message: `Slutdatoen ligger før tidligst lovlige slutdato.`,
  },
  {
    code: 100754,
    message: `Der skete en fejl i forbindelse med at sætte sikkerhedsindstilling.`,
  },
  {
    code: 100755,
    message: `Det lykkedes ikke at sætte den angivne sikkerhedsindstilling.`,
  },
  {
    code: 100756,
    message: `Ladestanderen understøtter ikke sikkerhedsindstilling.`,
  },
  {
    code: 100757,
    message: `Der er ikke tilkoblet et brugbart id-tag til ladestanderen.`,
  },
  {
    code: 30005,
    message: `Bestilling af flytning fejlede, da installationen ikke er færdig installeret`,
  },
  {
    code: 10125,
    message: `Installationen er ikke færdig installeret.`,
  },
  {
    code: 10126,
    message: `Installationen matcher ikke det indsendte laderstander-ID.`,
  },
  {
    code: 10128,
    message: `Der er ikke bestilt flytning eller nedtagning for denne ladeboks, og derfor kan den ikke nedtages. Hvis ladeboksen skal udskiftes med en anden, skal du blot bruge menupunktet "Udskift ladeboks".`,
  },
  {
    code: 10129,
    message: `Der er sket en fejl i forbindelse med indlæsning af ladestanderdetaljer`,
  },
  {
    code: 10134,
    message: `Der er sket en fejl i forbindelse med annullering`,
  },
  {
    code: 10138,
    message: `Der er sket en fejl i forbindelse med opsigelse`,
  },
  {
    code: 10142,
    message: `Ladestanderen kan ikke udskiftes, fordi abonnementet er opsagt`,
  },
  {
    code: 100210,
    message: `Kan ikke skifte ejerskab eller kundetype på et produkt i brug`,
  },
  {
    code: 12121,
    message: `Der opstod en fejl under hentning af installatørpartner virksomheder`,
  },
  {
    code: 500009,
    message: `Kan ikke fortryde, når ladestanderen er installeret`,
  },
  {
    code: 12140,
    message: `Der opstod en fejl under skift af installatørpartner. Screeningen var i forkert status`,
  },
  {
    code: 12141,
    message: `Der opstod en fejl under skift af installatørpartner. Kunne ikke finde maks. ekstraomkostninger for installationen`,
  },
  {
    code: 12146,
    message: `Kan ikke skifte installatørpartner på en kunde, som tidligere har valgt ingen installation, da der ikke er bestilt hardware.`,
  },
  {
    code: 12147,
    message: `Kan ikke skifte til ingen installation på en kunde, som tidligere har valgt en installatørpartner, da hardware allerede er bestilt.`,
  },
  {
    code: 12145,
    message: `Den valgte installatørpartner er allerede tildelt`,
  },
  {
    code: 12142,
    message: `Screening filen kunne ikke findes`,
  },
  {
    code: 500019,
    message: `De to produkter skal have samme ejerskab`,
  },
  {
    code: 500020,
    message: `Det er ikke tilladt for HLF kunder at overdrage installation`,
  },
  {
    code: 500021,
    message: `Intet aktivt produkt blev fundet`,
  },
  {
    code: 500023,
    message: `Eksisterende abonnement blev ikke fundet`,
  },
  {
    code: 500024,
    message: `Eksisterende installation blev ikke fundet`,
  },
  {
    code: 500025,
    message: `Abonnement mangler G4 kontonr`,
  },
  {
    code: 500027,
    message: `Installationskøbet skal være faktureret før overdragelse er muligt. Fakturering sker automatisk 15 dage efter bestilling`,
  },
  {
    code: 500028,
    message: `Installationen skal være i status 'Afsluttet' før overdragelse er muligt`,
  },
  {
    code: 500029,
    message: `Abonnementet er allerede under overdragelse.`,
  },
  {
    code: 100050,
    message: `Kan ikke skifte produkt, da det nye produkt ikke matcher.`,
  },
  {
    code: 100053,
    message: `Kan ikke skifte produkt, da kundens abonnement er opsagt, før produktskifet kan træde i kraft.`,
  },
  {
    code: 1000501,
    message: `Kunden har et fremtidigt produktskifte, der ændrer kundetype eller ejerskab. Abonnementet kan først ændres efter dette skifte.`,
  },
  {
    code: 12128,
    message: `Der er sket en fejl i forbindelse med at hente kundens e-mail adresse.`,
  },
  {
    code: 12132,
    message: `Screening er i den forkerte status.`,
  },
  {
    code: 12135,
    message: `HLF aftalenummer kunne ikke findes.`,
  },
  {
    code: 12137,
    message: `Fejl i HLF-abonnement.`,
  },
  {
    code: 13002,
    message: `Screening er i den forkerte status.`,
  },
  {
    code: 13332,
    message: `Der er allerede bestilt flytning. Annuller den eksisterende flytning, og prøv igen.`,
  },
  {
    code: 13341,
    message: `Der blev ikke fundet nogen HLF aftale for det abonnementet`,
  },
  {
    code: 16501,
    message: `Ladestanderen er ikke nedtaget på den gamle adresse.`,
  },
  {
    code: 15002,
    message: `Der er ikke bestilt flytning af installationen.`,
  },
  {
    code: 16000,
    message: `Kunne ikke finde idtag-gruppe.`,
  },
  {
    code: 17000,
    message: `Kunne ikke afgøre din organisation.`,
  },
  {
    code: 100111,
    message: `Filen findes allerede.`,
  },
  {
    code: 100112,
    message: `Lagervarenummeret eksisterer allerede.`,
  },
  {
    code: 100130,
    message: `Lagerkomponenten blev ikke fundet.`,
  },
  {
    code: 100213,
    message: `Produktet kan ikke slettes, da det stadig er aktivt.`,
  },
  {
    code: 100214,
    message: `Produktet kan ikke slettes, da det har aktive abonnementer tilknyttet.`,
  },
  {
    code: 30006,
    message: `Ugyldig installationsstatus`,
  },
  {
    code: 30009,
    message: `Abonnementet er ikke tilknyttet installationen`,
  },
  {
    code: 100400,
    message: `Installationen er allerede nedtaget`,
  },
  {
    code: 100401,
    message: `Abonnementet er ikke aktivt`,
  },
  {
    code: 100402,
    message: `Opsigelsesdatoen er overskredet`,
  },
  {
    code: 100403,
    message: `Abonnementet er annulleret i stedet for opsagt`,
  },
  {
    code: 100404,
    message: `Abonnementet er ikke opsagt`,
  },
  { code: 100133, message: `Lagerkomponenten er tilknyttet et hardwareprodukt og kan derfor ikke slettes.` },
  { code: 100134, message: `Producenten blev ikke fundet` },
  { code: 100135, message: `Producenten er tilknyttet et hardwareprodukt og kan derfor ikke slettes.` },
  { code: 100300, message: `Producentens navn findes allerede` },
  { code: 100120, message: `Hardwareproduktet blev ikke fundet` },
  { code: 100126, message: `Hardwareproduktet er aktivt og kan derfor ikke slettes` },
  { code: 200111, message: `Abonnementet er ikke under overdragelse` },
  { code: 101500, message: `Kundetypen blev skiftet men kundemail kunne ikke sendes` },
  { code: 101504, message: `Adressen kan ikke skiftes automatisk efter installationen er udført.` },
  { code: 101505, message: `Adressen kan ikke skiftes da abonnement bestillingen er blevet annulleret.` },
  { code: 10106, message: `Kunne ikke fakturere. Prøv igen om 5 minutter.` },
  { code: 11157, message: `Hardwareprodukt bestilling allerede sendt` },
  { code: 100132, message: `Bestillingen er ikke tilknyttet et produkt` },
  { code: 11154, message: `Bestillingen er allerede sendt til producenten` },
  { code: 11153, message: `Abonnementet er afmeldt` },
  { code: 11155, message: `Hardwareproduktet er ikke det senest tilknyttede til produktet` },
  { code: 11156, message: `Tilbehøret er ikke tilknyttet et hardwareprodukt` },
  { code: 415003, message: `En organisation med samme navn eksisterer allerede` },
  { code: 415002, message: `Organisationen er allerede oprettet` },
  { code: 14400, message: `Hvis ladebrikken gøres privat, kan kunden ikke længere foretage HLF-ladninger` },
  { code: 14401, message: `Ladebrikken findes ikke eller tilhører ikke kunden` },
  { code: 14402, message: `Kunden har ingen tilknyttede ladebrikker, eller installationen er nedtaget` },
  { code: 14403, message: `Tilkobl en firmabilsbrik til ladestanderen for at sætte den i åben tilstand.` },
  {
    code: 10028,
    message: `Kampagnen er eller har været aktiv og kan derfor ikke slettes.`,
  },
  {
    code: 10029,
    message: `Kampagnen er ikke aktiv og kan derfor ikke deaktiveres.`,
  },
  {
    code: 10025,
    message: `Kampagnen overlapper med en eksisterende kampagne`,
  },
  {
    code: 10008,
    message: `Priser må ikke ændres på en aktiv kampagne`,
  },
  {
    code: 100138,
    message: `Den angivne Bilinfoforhandler blev ikke fundet`,
  },
  {
    code: 10031,
    message: `Ukendt sortering`,
  },
  {
    code: 13339,
    message: `Abonnementet har allerede et fremtidigt HLF aftaleskift`,
  },
  {
    code: 13338,
    message: `Abonnementet er opsagt inden HLF aftaleskiftet træder i kraft`,
  },
  {
    code: 600120,
    message: `Kunne ikke finde G4 kontoen for det angivne kontonummer.`,
  },
  {
    code: 600118,
    message: `Kunne ikke finde G4 kontoen for det angivne aftalenummer`,
  },
  {
    code: 100054,
    message: `Kunden har allerede det valgte produkt. Annuller det planlagte produktskifte, hvis du ønsker at beholde det nuværende produkt.`,
  },
  {
    code: 100055,
    message: `Der er allerede planlangt et skifte til dette produkt.`,
  },
  {
    code: 11160,
    message: `Det fremtidige produkt er allerede faktureret, og skiftet kan derfor ikke annulleres.`,
  },
  {
    code: 10035,
    message: `Startdatoen på en produktkampagne skal være i fremtiden.`,
  },
  {
    code: 30101,
    message: `Abonnementet er ikke aktivt`,
  },
  {
    code: 100780,
    message: `Ladestander-ID ugyldigt`,
  },
  {
    code: 10079,
    message: `Fejl ved kald til cs management `,
  },
  {
    code: 12139,
    message: `Den valgte installatør understøtter ikke bestillinger med lastbalancering`,
  },
];
